<template lang="pug">
div
  Header(apiname='tech-info',headname='技術情報')
  .card
    .container-fluid
      h3.box-title 技術情報
      List(apiname='tech-info', editPath='edit')
</template>

<script>
import Header from '@/views/components/swan/common/SubHeader'
import List from '@/views/components/swan/common/List'

export default {
  name: 'TechInfo',
  data () {
    return {}
  },
  components: {
    Header,
    List
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.card {
  padding: 16px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/techInfo/list.vue